/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';
import cx from 'classnames';
import { Separator } from '@base-ui/react/separator';

import { SearchLocationsControl } from './LocationsCombobox/SearchLocationsControl';
import { BookingTypeSelect } from './BookingTypeSelect/BookingTypeSelect';

import styles from './SearchFilterCombo.module.scss';

interface SearchFilterComboProps {
    size?: 'sm' | 'md';
}

export function SearchFilterCombo({ size = 'md' }: SearchFilterComboProps) {
    const [isSearchExpanded, setIsSearchExpanded] = React.useState(false);

    return (
        <div
            className={cx(styles.SearchFilterCombo, {
                [styles.isExpanded]: isSearchExpanded,
                [styles.sizeSmall]: size === 'sm',
            })}
        >
            <SearchLocationsControl
                isSearchExpanded={isSearchExpanded}
                setIsSearchExpanded={setIsSearchExpanded}
            />

            <div
                className={cx(styles.actions, {
                    [styles.isHidden]: isSearchExpanded,
                })}
                aria-hidden={isSearchExpanded}
            >
                <div data-nubbin />
                <Separator
                    orientation="vertical"
                    className={styles.Separator}
                    data-action-item
                />
                <div data-action-item>
                    <BookingTypeSelect isDisabled={isSearchExpanded} />
                </div>
            </div>
        </div>
    );
}
